import { useEffect, useState } from "react";
import NavBar from "../../../Navbar/Navbar";
import Cookies from "js-cookie";
import fetchClient from "../../../../AdminAPI/ClientList";
import fetchModel from "../../../../AdminAPI/ModelADM";
import { Link, useNavigate } from "react-router-dom";
import { setEnvironmentColors } from "../../../Utils/EnvironnementColor";
import "./AdminHome.css";
import { useTranslation } from "react-i18next";

const AdminHome = () => {
  const idToken = Cookies.get("Token");
  const [client, setClient] = useState([]);
  const [model, setModel] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();
  const [clientSearch, setClientSearch] = useState("");
  const [modelSearch, setModelSearch] = useState("");
  const [headerColor, setHeaderColor] = useState("#235073");
  const [colorFilter, setColorFilter] = useState("#235073");
  const [colorFilterAction, setColorFilterAction] = useState("#ffffff");


  useEffect(() => {
    const deleteCookies = async () => {
      Cookies.remove("modelIdHome");
      Cookies.remove("modelNameHome");
      Cookies.remove("modelComponentHome");
      Cookies.remove("clientId");
      Cookies.remove("modelId");
    };
    deleteCookies();
  }, []);

 useEffect(() => {
    setEnvironmentColors([
      [setHeaderColor, "headerColor"],
      [setColorFilter, "colorFilter"]
    ]);
  }, []);

  useEffect(() => {
    const FetchModelClient = async () => {
      setIsLoading(true);
      try {
        const ClientData = await fetchClient(idToken);
        setClient(ClientData);
      } catch (error) {
        console.error("Erreur lors du chargement des clients", error);
      }
      try {
        const ModelData = await fetchModel(null, idToken);
        const AllModels = ModelData.map((model) => ({
          id: model.ModelId,
          name: model.ModelName,
          component: model.ModelComponent,
          allModel: model,
        }));
        setModel(AllModels);
      } catch (error) {
        console.error("Erreur lors du chargement des models", error);
      } finally {
        setIsLoading(false);
      }
    };
    FetchModelClient();
  }, []);

  const handleClientClick = (clientId) => {
  localStorage.setItem("viewMode", "client");
  Cookies.set("clientId", clientId);
  Cookies.remove("modelId");
  navigate("/Admin/AdmLotsTable");
};

const handleModelClick = (modelId, modelName, modelComponent, allModel) => {
  localStorage.setItem("viewMode", "model");
  Cookies.set("modelIdHome", modelId);
  Cookies.set("modelNameHome", modelName);
  Cookies.set("modelComponentHome", modelComponent);
  Cookies.set("modelHome", JSON.stringify(allModel));
  Cookies.remove("clientId");
  navigate("/Admin/AdmLotsTable");
};

  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <>
      <NavBar />
    <div id="dashboard">

      {/* ===== CARD CLIENTS ===== */}
      <div className="main-card">
        <div className="list-block">
          <table>
            <thead style={{ backgroundColor: colorFilter }}>
              <tr>
                <th>{t("List Clients")}</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ backgroundColor: headerColor }}>
                <td>
                  <input
                    type="text"
                    placeholder={t("Search clients...")}
                    className="search-bar text-dark"
                    onChange={(e) => setClientSearch(e.target.value)}
                  />
                </td>
              </tr>

              {client
                .filter((c) =>
                  c.ClientId.toLowerCase().includes(clientSearch.toLowerCase())
                )
                .map((c) => (
                  <tr key={c.ClientId}>
                    <td>
                  <span
                    className="clickable"
                        onClick={() => handleClientClick(c.ClientId)}
                  >
                        {c.ClientId}
                  </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* ===== CARD MODELS ===== */}
      <div className="main-card">
        <div className="list-block">
          <table>
            <thead style={{ backgroundColor: colorFilter }}>
              <tr>
                <th>{t("List Models")}</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ backgroundColor: headerColor }}>
                <td>
                  <input
                    type="text"
                    placeholder={t("Search models...")}
                    className="search-bar text-dark"
                    onChange={(e) => setModelSearch(e.target.value)}
                  />
                </td>
              </tr>

              {model
                .filter((m) =>
                  m.name.toLowerCase().includes(modelSearch.toLowerCase())
                )
                .map((m) => (
                  <tr key={m.id}>
                    <td>
                  <span
                    className="clickable"
                    onClick={() =>
                          handleModelClick(
                            m.id,
                            m.name,
                            m.component,
                            m.allModel
                          )
                    }
                  >
                        {m.id} — {m.name}
                  </span>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        </div>
      </div>
    </>
  );

};

export default AdminHome;
